import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudBudget = () => import('./staff/crudBudget')

Vue.use(Router)

const router =
  [
    {
      path: '/st/budgets',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'BudgetsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Presupuestos',
          }                                  
        },        
        {
          path: 'generate',
          name: 'BudgetsStaffCrudBudget',
          component: ViewStaffCrudBudget,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de presupuestos',
          }                                  
        },             
      ]
    },

    {
      path: '/cu/budgets',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/budgets',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
